import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './PricesInHours.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import Loader from 'components/UI/Loader/Loader'
import AddPricesInHoursModal from './AddPricesInHoursModal/AddPricesInHoursModal'
import RowPrice from './RowPrice/RowPrice'

const initPagination = {
  page: 1,
  limit: 10,
}

const PricesInHours = () => {
  const [prices, setPrices] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const fetchPrices = () => {
    superAxiosRequest({
      method: 'get',
      link: 'groups/price_sums',
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setPrices(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchPrices()
  }, [pagination])

  const addPrice = () => {
    const ms = {
      modalBodyComponent: () => <AddPricesInHoursModal />,
      button: 'Save',
      link: 'groups/price_sums',
      title: 'Добавить стоимость курса',
      isResponsive: true,
      onSubmitSuccess: () => {
        fetchPrices()
      },
      valid: {
        hours_sum: 'required',
        hours_type: 'required',
        name: 'required',
        price_sum: 'required',
        type: 'required',
        locations: 'required',
      },
    }

    asideModalStore.activity(ms, {})
  }

  const onBeforeSubmitFunc = (data) => {
    return {
      ...data,
      hours_type: data?.hours_type?.id,
      company: data?.company?.id,
    }
  }
  const editPrice = (data) => {
    const updateData = {
      ...data,
      locations: data.locations?.map((location) => location.id) || [],
    }
    const ms = {
      modalBodyComponent: () => <AddPricesInHoursModal isEdit />,
      button: 'Save',
      link: `groups/price_sums/${updateData?.id}`,
      title: 'Редактировать стоимость курса',
      isResponsive: true,
      is_put: true,
      onSubmitSuccess: (data) => {
        setPrices((prev) => {
          return {
            ...prev,
            result: prev.result.map((age) =>
              age.id === data.id ? { ...age, ...data } : age,
            ),
          }
        })
      },
      onBeforeSubmit: onBeforeSubmitFunc,
      valid: {
        hours_sum: 'required',
        hours_type: 'required',
        name: 'required',
        price_sum: 'required',
        type: 'required',
        locations: 'required',
      },
    }
    asideModalStore.activity(ms, updateData)
  }

  const deletePrice = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the price?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `groups/price_sums/${data?.id}`,
        }
        superAxiosRequest(apiConf).then(() => {
          setPrices((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== data?.id),
          }))
        })
      }
    })
  }

  const action = (action, e, items) => {
    const actions = new Map([
      ['edit', () => editPrice(items)],
      ['delete', () => deletePrice(items)],
    ])
    return actions.get(action)?.()
  }

  return (
    <div>
      <div className={st.header}>
        <PageHeader title={'Цены в часах'}>
          <HeaderAddButton title={'Добавить'} onClick={addPrice} />
        </PageHeader>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            Записей: {prices?._meta?.count_items}
          </div>
          <div>
            {prices?.result?.map((price, index) => (
              <RowPrice
                key={price.id}
                price={price}
                index={index}
                action={action}
              />
            ))}
          </div>
        </div>
      )}
      <div className={st.pagination}>
        {prices?._meta.count_items > 10 && (
          <Pagination
            limit={pagination.limit}
            count={prices._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default PricesInHours
